import { AxiosRequestConfig } from 'axios'
import createAPIClient from '../services/apiClient'
import { AssetGroup, AssetGroupInput, AuroraAssetGroup, AuroraAssetGroupInput } from '../types'

const api = createAPIClient('/v2')

export async function getAssetGroups(config?: AxiosRequestConfig) {
  const response = await api.get<AssetGroup[]>('/asset-groups', config)

  return response.data
}

export async function getAssetGroup(id: string, config?: AxiosRequestConfig) {
  const response = await api.get<AssetGroup>(`/asset-groups/${id}`, config)

  return response.data
}

export async function createAssetGroup(input: AssetGroupInput, config?: AxiosRequestConfig) {
  const response = await api.post<AssetGroup>('/asset-groups', input, config)

  return response.data
}

export async function createAuroraAssetGroup(
  input: Omit<AuroraAssetGroupInput, 'assetIds' | 'customData'>,
  config?: AxiosRequestConfig
) {
  const response = await api.post<AuroraAssetGroup>('/asset-groups', input, config)

  return response.data
}

export async function updateAssetGroup(
  id: string,
  input: Omit<AssetGroupInput, 'projectId'>,
  config?: AxiosRequestConfig
) {
  const response = await api.patch<AssetGroup>(`/asset-groups/${id}`, input, config)

  return response.data
}

export async function updateAuroraAssetGroup(
  id: string,
  input: Partial<Omit<AuroraAssetGroupInput, 'projectId'>>,
  config?: AxiosRequestConfig
) {
  const response = await api.patch<AuroraAssetGroup>(`/asset-groups/${id}`, input, config)

  return response.data
}
